export default __webpack_public_path__ + "static/data-customisation-99a9d7c589507afbaf52a068ab84c105.png";